export type ELockInfoRequest = {
  lockName: string
  orderId: number
  employeeId: number
  tokenType?: 0 | 1
  /** Если токен нужно получить для замка который не установлен на ПВЗ, проставляется true,
   * в таком случае будет использовано поле lock_name вместо pickpoint_id.
   */
  lockNoSet: boolean
  /** Время в течении которого можно воспользоваться ключом.
   * Время действия с момента получения токена + ttl
   * (время в часах, значение ttl в диапазоне 1-6, при tll = 0 либо > 6, значение по умолчанию - 6)
   */
  ttl?: number
}

export type ELockConnectInfoDTO = {
  /** токен для открытия замка */
  virtualKey: string
  /** название точки доступа (wi-fi) */
  ssid: string
  /** пароль к точке доступа (wi-fi) */
  psk: number
  /** Время истечения срока действия ключа UNIX (отметка времени в секундах) */
  endDate: string
  linkToOpen: string
}

export enum ELockPhoto {
  doorFromInside = 'doorFromInsidePhoto',
  doorFromTheEnd = 'doorFromTheEndPhoto',
  controller = 'controllerPhoto',
  /** Тип фотографий в форме активации без замка */
  reason = 'ELockReasonPhoto',
}

export type ELockFileItem = {
  url: string
  type: ELockPhoto
  size: number
}

export type ActivateELockRequest = {
  orderId: number
  eLockName: string
  photos: ELockFileItem[]
}

export enum ElockReason {
  none = 'PickpointOrderElockNoReason',
  other = 'PickpointOrderElockOtherReason',
  glassDoor = 'PickpointOrderElockGlassDoor',
  northernRegion = 'PickpointOrderElockNorthernRegion',
}

export type SetELockReasonPhotoType = {
  type: string
  url: string
}

export type OrderELockInfoDTO = {
  reason: ElockReason
  photos: {
    type: ELockPhoto
    url: string
  }[]
  status: ElockInfoStatus
  description: string
  /**  признак активации */
  enabled: boolean
  elockName: string
}

export enum ElockInfoStatus {
  none = 'PickpointOrderElockStatusNONE',
  pending = 'PickpointOrderElockStatusPENDING',
  remark = 'PickpointOrderElockStatusREVISION',
  approved = 'PickpointOrderElockStatusAPPROVED',
}

export type SetELockReasonRequest = {
  orderId: number
  reason: ElockReason
  description: string
  photos: SetELockReasonPhotoType[]
}

export type UpdateELockRequest = SetELockReasonRequest & {
  eLockName: string
  photos: SetELockReasonPhotoType[] | ELockFileItem[]
}
